import { render, staticRenderFns } from "./MainMiddlePanelForDecanat.vue?vue&type=template&id=65b7bf49&scoped=true&"
import script from "./MainMiddlePanelForDecanat.vue?vue&type=script&lang=js&"
export * from "./MainMiddlePanelForDecanat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7bf49",
  null
  
)

export default component.exports